import { Stack, SvgIcon, Typography } from '@mui/material';
import { ReactNode } from 'react';

export type InfoItemProps = {
  icon: ReactNode;
  text: string;
  direction?: 'row' | 'column';
  style?: React.CSSProperties;
};

export function InfoItem({ icon, text, direction = 'row', style = {} }: InfoItemProps) {
  return (
    <Stack direction={direction} alignItems="center" spacing={1} style={style}>
      <SvgIcon
        sx={{
          width: '20px',
          height: '20px',
        }}
      >
        {icon}
      </SvgIcon>
      <Typography
        variant="caption"
        sx={{
          fontWeight: 500,
          fontSize: '13px !important',
        }}
      >
        {text}
      </Typography>
    </Stack>
  );
}
